(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["avis-section"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('eve-reviews')) {
    customElements.define('eve-reviews', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        const dataElement = this.querySelector('[data-review-data]');
        if (!dataElement) return;
        let data;
        try { data = JSON.parse(dataElement.textContent); } catch (_) { return; }
        this.initialized = true;
        this.reviews = (data.blocks || []).concat((data.reviews || []).map(review => ({text:review.avis, name:review.name, date:review.date, note:review.note, shortDate:true})));
        this.list = this.querySelector('.avis-content');
        this.count = this.list.children.length;
        this.button = this.querySelector('.voirplus');
        this.allLink = this.querySelector('.voirtout');
        if (this.button && this.count < this.reviews.length) {
          this.button.hidden = false;
          this.allLink.style.display = 'none';
          this.button.addEventListener('click', () => this.showMore());
        }
        dataElement.remove();
      }
      appendText(target, html) {
        const source = new DOMParser().parseFromString(String(html || ''), 'text/html');
        const append = (node, parent) => {
          if (node.nodeType === 3) { parent.append(document.createTextNode(node.textContent)); return; }
          if (node.nodeType !== 1 || ['SCRIPT', 'STYLE', 'IFRAME', 'OBJECT'].includes(node.tagName)) return;
          let destination = parent;
          if (['P', 'BR', 'STRONG', 'EM', 'B', 'I', 'U'].includes(node.tagName)) {
            destination = document.createElement(node.tagName.toLowerCase());
            parent.append(destination);
          }
          Array.from(node.childNodes).forEach(child => append(child, destination));
        };
        Array.from(source.body.childNodes).forEach(node => append(node, target));
      }
      showMore() {
        const fragment = document.createDocumentFragment();
        const end = Math.min(this.count + Number(this.dataset.pageSize || 3), this.reviews.length);
        for (let index = this.count; index < end; index++) {
          const review = this.reviews[index];
          const card = document.createElement('div'); card.className = 'avis';
          const stars = document.createElement('div'); stars.className = 'star'; stars.setAttribute('aria-hidden', 'true');
          const rating = Math.min(5, Math.max(1, Number(review.note) || 5));
          for (let star = 0; star < rating; star++) {
            const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
            svg.setAttribute('width','23'); svg.setAttribute('height','23'); svg.setAttribute('viewBox','0 0 26 26'); svg.setAttribute('fill','#FFE033');
            const shape = document.createElementNS('http://www.w3.org/2000/svg', 'path');
            shape.setAttribute('d','M13 0 17.3 8.2 26 9.7 19.9 16 21.2 25 13 21 4.8 25 6.1 16 0 9.7 8.7 8.2Z');
            svg.append(shape); stars.append(svg);
          }
          const accessibleRating = document.createElement('span'); accessibleRating.className = 'visually-hidden'; accessibleRating.textContent = rating + '/5';
          const text = document.createElement('div'); text.className = 'avistext'; this.appendText(text, review.text);
          const footer = document.createElement('div'); footer.className = 'footer-avis';
          const name = document.createElement('span'); name.textContent = review.name || '';
          const date = document.createElement('div'); date.className = 'date';
          let displayDate = String(review.date || '');
          if (review.shortDate) displayDate = displayDate.split(' ')[0].split('/').slice(0, 2).join('/');
          date.textContent = (this.dataset.published || '') + ' ' + displayDate.split('/').join(this.dataset.dateSeparator || '/');
          footer.append(name, date); card.append(stars, accessibleRating, text, footer); fragment.append(card);
        }
        this.list.append(fragment); this.count = end;
        this.querySelector('[data-review-status]').textContent = this.count + ' / ' + this.reviews.length;
        if (this.count >= this.reviews.length) {
          this.button.hidden = true;
          this.allLink.style.display = 'inline-flex';
          this.allLink.focus({preventScroll: true});
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer2"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
